import { Component, Input, Output, ViewChild, EventEmitter } from '@angular/core';



@Component({
  selector: 'huf-eur-switch',
  templateUrl: './huf-eur-switch.component.html',
  styleUrls: ['./huf-eur-switch.component.scss']
})


export class HufEurSwitchComponent {

  @Input() selectedCurrency: string = "HUF";
  @Output() selectedCurrencyChanged: EventEmitter<string> = new EventEmitter<string>();
  @ViewChild('currency_switch') hufEurSwitch: HTMLDivElement | undefined;

  /**
   *
   */
  constructor() {
    this.selectCurrency(this.selectedCurrency)
  }
  currencyStyle(payment: string) {
    let styles = {};
    styles["position"] = "absolute";
    styles["width"] = "50%";
    styles["height"] = "100%";
    styles["border-radius"] = "25px";
    // styles["border"] = "5px solid #222";
    styles["transition"] = "transform 0.3s";
    styles["top"] = "0";
    styles["left"] = "0";
    styles["box-sizing"] = "border-box";
    styles["flex"] = "1";
    styles["text-align"] = "center";
    styles["padding"] = "5px 10px";
    styles["font-size"] = "15px";
    styles["font-weight"] = "500";
    styles["transition"] = "color 0.3s";
    styles["position"] = "relative";

    if (this.selectedCurrency === payment) {
      styles["background-color"] = "white";
      styles["z-index"] = "1";
    }
    else {
      styles["z-index"] = "2";
      styles["color"] = "white";
    }
    return styles;
  }

  selectCurrency(currency: string) {
    this.selectedCurrency = currency;
    this.selectedCurrencyChanged.emit(currency);
  }
}
